module.exports = __webpack_public_path__ + "img/no-message.1e5a245e.svg";